import Color from 'color';
import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { useDomain } from 'components/domain/DomainProvider';
/**
 * @component ThemeProvider
 * @since 1.0.0
 */
export function ThemeProvider(props) {
    const node = useRef(null);
    const { options } = useDomain();
    useEffect(() => {
        const theme = options.theme;
        if (theme == null) {
            return;
        }
        const base = {};
        const dark = {};
        if (theme.colors)
            Object.entries(theme.colors).forEach((entry) => {
                const [color, value] = entry;
                if (value.shades)
                    Object.entries(value.shades).forEach((entry) => {
                        let [shade, value] = entry;
                        const shadeKey = `--${color}-${shade}`;
                        switch (shade) {
                            case '100':
                                shade = new Color(value).darken(0.7).hex();
                                break;
                            case '200':
                                shade = new Color(value).darken(0.6).hex();
                                break;
                            case '300':
                                shade = new Color(value).darken(0.5).hex();
                                break;
                            case '400':
                                shade = value;
                                break;
                            case '500':
                                shade = new Color(value).lighten(0.1).hex();
                                break;
                            case '600':
                                shade = new Color(value).lighten(0.2).hex();
                                break;
                            case '700':
                                shade = new Color(value).lighten(0.3).hex();
                                break;
                        }
                        base[shadeKey] = value;
                        dark[shadeKey] = shade;
                    });
            });
        if (theme.primaryColor) {
            base['--primary'] = `var(--${theme.primaryColor})`;
            base['--primary-100'] = `var(--${theme.primaryColor}-100)`;
            base['--primary-200'] = `var(--${theme.primaryColor}-200)`;
            base['--primary-300'] = `var(--${theme.primaryColor}-300)`;
            base['--primary-400'] = `var(--${theme.primaryColor}-400)`;
            base['--primary-500'] = `var(--${theme.primaryColor}-500)`;
            base['--primary-600'] = `var(--${theme.primaryColor}-600)`;
            base['--primary-700'] = `var(--${theme.primaryColor}-700)`;
        }
        if (theme.successColor) {
            base['--success'] = `var(--${theme.successColor})`;
            base['--success-100'] = `var(--${theme.successColor}-100)`;
            base['--success-200'] = `var(--${theme.successColor}-200)`;
            base['--success-300'] = `var(--${theme.successColor}-300)`;
            base['--success-400'] = `var(--${theme.successColor}-400)`;
            base['--success-500'] = `var(--${theme.successColor}-500)`;
            base['--success-600'] = `var(--${theme.successColor}-600)`;
            base['--success-700'] = `var(--${theme.successColor}-700)`;
        }
        if (theme.warningColor) {
            base['--warning'] = `var(--${theme.warningColor})`;
            base['--warning-100'] = `var(--${theme.warningColor}-100)`;
            base['--warning-200'] = `var(--${theme.warningColor}-200)`;
            base['--warning-300'] = `var(--${theme.warningColor}-300)`;
            base['--warning-400'] = `var(--${theme.warningColor}-400)`;
            base['--warning-500'] = `var(--${theme.warningColor}-500)`;
            base['--warning-600'] = `var(--${theme.warningColor}-600)`;
            base['--warning-700'] = `var(--${theme.warningColor}-700)`;
        }
        if (node.current) {
            node.current.innerHTML = `

				:root {

					/* Base Colors */

					${echo(base)}

					/* Typed Colors */

					--primary: var(--${theme.primaryColor});
					--success: var(--${theme.successColor});
					--warning: var(--${theme.warningColor});

					/* Primary Shades */

					--primary-100: var(--${theme.primaryColor}-100);
					--primary-200: var(--${theme.primaryColor}-200);
					--primary-300: var(--${theme.primaryColor}-300);
					--primary-400: var(--${theme.primaryColor}-400);
					--primary-500: var(--${theme.primaryColor}-500);
					--primary-600: var(--${theme.primaryColor}-600);
					--primary-700: var(--${theme.primaryColor}-700);

					/* Success Shades */

					--success-100: var(--${theme.successColor}-100);
					--success-200: var(--${theme.successColor}-200);
					--success-300: var(--${theme.successColor}-300);
					--success-400: var(--${theme.successColor}-400);
					--success-500: var(--${theme.successColor}-500);
					--success-600: var(--${theme.successColor}-600);
					--success-700: var(--${theme.successColor}-700);

					/* Warning Shades */

					--warning-100: var(--${theme.warningColor}-100);
					--warning-200: var(--${theme.warningColor}-200);
					--warning-300: var(--${theme.warningColor}-300);
					--warning-400: var(--${theme.warningColor}-400);
					--warning-500: var(--${theme.warningColor}-500);
					--warning-600: var(--${theme.warningColor}-600);
					--warning-700: var(--${theme.warningColor}-700);

				}

				/* Dark Colors */

				@media(prefers-color-scheme: dark) {
					:root {
						${echo(dark)}
					}
				}

			`;
        }
    }, [options.theme]);
    return (React.createElement(Fragment, null,
        React.createElement("style", { type: "text/css", ref: node }),
        props.children));
}
/**
 * @function echo
 * @since 1.0.0
 * @hidden
 */
function echo(vars) {
    return Object.entries(vars)
        .map(([key, val]) => key + ':' + val + ';')
        .join('\n');
}
